export default __webpack_public_path__ + "static/media/11_photo.fa3e6455.jpg";